/**
 * 页面头部组件
 * 提供页面标题、面包屑导航功能
 */
<template>
  <div class="page-header" v-if="showHeader">
    <div class="page-header-left">
      <div class="page-title">
        <i :class="pageIcon" v-if="pageIcon"></i>
        <span>{{ pageTitle }}</span>
      </div>
      <el-breadcrumb separator="/" class="page-breadcrumb" v-if="breadcrumbList.length > 1">
        <el-breadcrumb-item 
          v-for="(item, index) in breadcrumbList" 
          :key="index"
          :to="index < breadcrumbList.length - 1 ? item.path : null">
          {{ item.name }}
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="page-header-right">
      <slot name="actions"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageHeader',
  props: {
    title: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    showBreadcrumb: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      menuMap: {}
    };
  },
  computed: {
    showHeader() {
      // 工作台页面不显示页面头部
      return this.$route.name !== 'workbench';
    },
    pageTitle() {
      if (this.title) return this.title;
      return this.getCurrentPageTitle();
    },
    pageIcon() {
      if (this.icon) return this.icon;
      return this.getPageIcon();
    },
    breadcrumbList() {
      if (!this.showBreadcrumb) return [];
      return this.generateBreadcrumb();
    }
  },
  created() {
    this.buildMenuMap();
  },
  methods: {
    buildMenuMap() {
      const menuList = this.$store.getters.menuGetter || [];
      this.traverseMenu(menuList);
    },
    traverseMenu(list, parent = null) {
      list.forEach(item => {
        this.menuMap[item.path] = {
          name: item.name,
          icon: item.icon,
          parent: parent
        };
        if (item.children && item.children.length > 0) {
          this.traverseMenu(item.children, item);
        }
      });
    },
    getCurrentPageTitle() {
      const path = this.$route.path;
      const menuInfo = this.menuMap[path];
      if (menuInfo) {
        return menuInfo.name;
      }
      // 从路由meta中获取
      if (this.$route.meta && this.$route.meta.title) {
        return this.$route.meta.title;
      }
      // 从面包屑配置中获取最后一项
      if (this.$route.meta && this.$route.meta.breadcrumb) {
        const breadcrumb = this.$route.meta.breadcrumb;
        return breadcrumb[breadcrumb.length - 1].name;
      }
      return '';
    },
    getPageIcon() {
      const path = this.$route.path;
      const menuInfo = this.menuMap[path];
      if (menuInfo && menuInfo.icon) {
        return menuInfo.icon;
      }
      // 默认图标映射
      const iconMap = {
        '/order': 'el-icon-s-order',
        '/financial': 'el-icon-money',
        '/resource': 'el-icon-s-data',
        '/scheduling': 'el-icon-date',
        '/operation': 'el-icon-s-operation',
        '/business': 'el-icon-s-shop',
        '/dataAnalysis': 'el-icon-s-data'
      };
      for (const key in iconMap) {
        if (path.startsWith(key)) {
          return iconMap[key];
        }
      }
      return 'el-icon-document';
    },
    generateBreadcrumb() {
      const breadcrumb = [];
      const path = this.$route.path;
      
      // 如果路由配置了面包屑，直接使用
      if (this.$route.meta && this.$route.meta.breadcrumb) {
        return this.$route.meta.breadcrumb;
      }
      
      // 从菜单结构生成面包屑
      const menuInfo = this.menuMap[path];
      if (menuInfo) {
        // 添加父级菜单
        if (menuInfo.parent) {
          breadcrumb.push({
            name: menuInfo.parent.name,
            path: menuInfo.parent.path
          });
        }
        // 添加当前页面
        breadcrumb.push({
          name: menuInfo.name,
          path: path
        });
      }
      
      return breadcrumb;
    }
  }
};
</script>

<style lang="less" scoped>
.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  background: #fff;
  border-radius: 8px;
  margin-bottom: 16px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);

  .page-header-left {
    display: flex;
    align-items: center;
    gap: 16px;

    .page-title {
      display: flex;
      align-items: center;
      gap: 8px;
      font-size: 18px;
      font-weight: 600;
      color: #303133;

      i {
        font-size: 20px;
        color: #2B77FF;
      }
    }

    .page-breadcrumb {
      padding-left: 16px;
      border-left: 1px solid #dcdfe6;

      /deep/ .el-breadcrumb__item {
        .el-breadcrumb__inner {
          font-size: 13px;
          color: #909399;

          &.is-link {
            color: #606266;
            font-weight: normal;

            &:hover {
              color: #2B77FF;
            }
          }
        }

        &:last-child {
          .el-breadcrumb__inner {
            color: #303133;
            font-weight: 500;
          }
        }
      }
    }
  }

  .page-header-right {
    display: flex;
    align-items: center;
    gap: 12px;
  }
}
</style>
